import './app.css'
import { Login } from './components/login/login';

function App() {
    return (<Login />);
};

export default App
